function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStateBlank = function SvgStateBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 64.7C265 64.7 64.7 265 64.7 512S265 959.3 512 959.3 959.3 759 959.3 512 759 64.7 512 64.7zm216.9 489.8H295.1c-23.5 0-42.5-19-42.5-42.5s19-42.5 42.5-42.5h433.8c23.5 0 42.5 19 42.5 42.5s-19 42.5-42.5 42.5z",
    style: {
      fill: "#ddd"
    }
  }));
};
export default SvgStateBlank;